import React, { useEffect, useState } from 'react';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';

const ScrollBlock = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsVisible(window.scrollY > 1500);
        };

        handleScroll();

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Признак для соседних кнопок (чат витрины встаёт рядом, а не под кнопку «Наверх»).
    useEffect(() => {
        if (typeof document === 'undefined') return undefined;
        document.body.classList.toggle('scroll-top-visible', isVisible);
        return () => document.body.classList.remove('scroll-top-visible');
    }, [isVisible]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    if (!isVisible) {
        return null;
    }

    return (
        <button
            type="button"
            className="scroll-block visible"
            onClick={scrollToTop}
            aria-label="Наверх"
        >
            <VerticalAlignTopIcon />
        </button>
    );
};

export default ScrollBlock;
